import PropTypes from 'prop-types';
import { withAppProps } from '@utils/with-app-props';
import { Col, Container, Row } from '../../components/grid';
import { CreateAccountForm } from '../../components/create-account-form';
import { Layout } from '../../components/layout';
import { useRedirectIfAuthenticated } from '../../hooks/useRedirectIfAuthenticated';
import FormBackground from '../../components/form-background';

const CreateAccount = ({ title }) => {
  useRedirectIfAuthenticated();

  return (
    <Layout title={title} noFooterMargin>
      <FormBackground>
        <Container>
          <Row mt="64px" mb="48px">
            <Col width={{ xs: 12 / 12, lg: 6 / 12 }} offset={[0, 0, 0, 3 / 12]}>
              <CreateAccountForm />
            </Col>
          </Row>
        </Container>
      </FormBackground>
    </Layout>
  );
};

CreateAccount.propTypes = {
  title: PropTypes.string,
};

CreateAccount.defaultProps = {
  title: undefined,
};

export const getStaticProps = withAppProps(async () => {
  return {
    props: {
      title: 'Create Account',
    },
  };
});

export default CreateAccount;
